/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 09:43:45
 * @LastEditTime: 2023-04-14 15:40:53
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/index.tsx
 */
import { DropDown, Menu } from '@/src/components/Antd';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import CommonHeader from '@/src/components/CommonHeader';
import {
  deleteReport,
  exportReport,
  getReportDetail,
  reportDetailEdit,
  reportDetailInit,
  saveReport,
} from '@/src/request/analytics/report';
import { NEW } from '@/src/tools/constant';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import {
  ICategory,
  IDateRange,
  IExportFormat,
  IOrderTime,
  IReportCurrencyType,
} from '@/src/types/common/report';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
//import { NEW } from 'src/tools/constant';
import { ELang } from '@/src/types/common/language';
import { Form, message } from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Spin } from 'src/components/Antd';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { convertRes2Blob } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import SendToEmail from './Components/SendToEmail';
import ReportConfig from './ReportConfig';
import ReportData from './ReportData';
import Table from './Table';
import { breadcrumbData } from './config';
import css from './css.module.less';
import useFilter from './useFilter';

const permissions = () => {
  const view_report_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.view_report_details_page,
      }),
    ],
  });
  const add_edit_report = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.add_edit_report,
      }),
    ],
  });
  const delete_report = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.delete_report,
      }),
    ],
  });
  return {
    view_report_details_page,
    add_edit_report,
    delete_report,
  };
};
const ReportsDetail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_report_details_page, add_edit_report, delete_report } =
    permissions();
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const history = useHistory();
  const { type, reportUuid } = useParams() as any;
  const [results, setResults] = useState([]);
  const [pageSize, setPageSize] = useState(1000);
  const [current, setCurrent] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [hasModified, setHasModified] = useState(
    reportUuid === NEW ? true : false,
  );
  const [filtersData, setFiltersData] = useState([]);
  const [refreshDate, setRefreshDate] = useState('');
  const [name, setName] = useState('');
  const [storeCurrencyCode, setStoreCurrencyCode] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [form] = Form.useForm();

  /** reportUuid === NEW,新建,初始化Report*/
  const { loading } = useRequest(
    () => reportDetailInit(current, pageSize, type),
    {
      ready: reportUuid === NEW && !!view_report_details_page,
      onSuccess: (res) => {
        const {
          report: {
            name,
            maskPii,
            reportCurrencyType,
            dateRange,
            beginDate,
            endDate,
            dimensions,
            metrics,
            filters,
            timeZone,
            storeCurrencyCode,
            dateRangeType,
          },
          results = [],
          totalCount = 0,
        } = res || {};
        const dateCurrent = new Date(); //获取系统当前时间
        setRefreshDate(moment(dateCurrent).format('MM/DD/YYYY'));
        setResults(results);
        setFiltersData(filters);
        setTotalCount(totalCount);
        setStoreCurrencyCode(storeCurrencyCode);
        setTimeZone(timeZone);
        setName(name);
        form.setFieldsValue({
          name,
          maskPii,
          reportCurrencyType,
          dateRange: { dateRange, beginDate, endDate, dateRangeType },
          dimensions,
          metrics,
          templateLang: ELang['en-GB'],
        });
      },
    },
  );

  /** Report 每次修改表单数据，刷新table和时间*/
  const { run: _reportDetailEdit, loading: editLoading } = useRequest(
    (data) => reportDetailEdit(current, pageSize, data),
    {
      manual: true,
      onSuccess: (res) => {
        const {
          report: { beginDate, endDate, dateRange, metrics },
          results = [],
          totalCount,
        } = res || {};
        const dateCurrent = new Date(); //获取系统当前时间
        setRefreshDate(moment(dateCurrent).format('MM/DD/YYYY'));
        setResults(results);
        setTotalCount(totalCount);
        form.setFieldsValue({
          dateRange: { dateRange, beginDate, endDate },
          metrics,
        });
      },
    },
  );

  /**保存Report*/
  const { run: _saveReport, loading: saveLoading } = useRequest(
    (data) => saveReport(data),
    {
      manual: true,
      onSuccess: (res) => {
        message.success(
          getI18n('reportSubscription.reportSubscriptionDetail.saved_msg'),
        );
        setHasModified(false);
        if (res.uuid) {
          history.replace(`/report/${type}/${res.uuid}`);
        }
      },
    },
  );

  /**删除Report*/
  const { run: _deleteReport } = useRequest(
    () => deleteReport({ uuids: [reportUuid] }),
    {
      manual: true,
      onSuccess: (res) => {
        message.success(getI18n('reports.reportdetailcommon.delsucc'));
        history.push(`/reportList`);
      },
    },
  );

  /**请求Report详情 */
  const { loading: getReportDetailLoading } = useRequest(
    () => getReportDetail(reportUuid),
    {
      ready: reportUuid && reportUuid !== NEW && !!view_report_details_page,
      onSuccess: (res) => {
        const {
          name,
          maskPii,
          reportCurrencyType,
          dateRange,
          beginDate,
          endDate,
          dimensions,
          metrics,
          filters,
          storeCurrencyCode,
          timeZone,
          templateLang,
          dateRangeType,
        } = res || {};

        const dateCurrent = new Date(); //获取系统当前时间
        setRefreshDate(moment(dateCurrent).format('MM/DD/YYYY'));
        setResults(results);
        // setFiltersData((filters || []).filter((i) => i.value));
        const _filters = filters.map((i) => {
          const type = get(i, 'type');
          if (type === IReportCurrencyType.TransactionNativeCurrency) {
            const options = get(i, 'options') || [];
            const _o = options.filter(
              (o) => get(o, 'value') || get(o, 'selected'),
            );
            return { ...i, options: _o };
          } else {
            return i;
          }
        });

        setFiltersData(_filters);
        setStoreCurrencyCode(storeCurrencyCode);
        setTimeZone(timeZone);
        setName(name);
        form.setFieldsValue({
          name,
          maskPii,
          reportCurrencyType,
          templateLang,
          dateRange: {
            dateRange,
            beginDate,
            endDate,
            dateRangeType:
              dateRangeType ||
              (type === ICategory.Customer
                ? IOrderTime.RegistrationDate
                : IOrderTime.OrderPaidTime),
          },
          dimensions,
          metrics,
        });
        _reportDetailEdit({
          ...res,
          dateRangeType:
            dateRangeType ||
            (type === ICategory.Customer
              ? IOrderTime.RegistrationDate
              : IOrderTime.OrderPaidTime),
        });
      },
    },
  );
  const { run: _exportReport, loading: exportLoading } = useRequest(
    (data) => exportReport(data),
    {
      manual: true,
      onSuccess: (res) => {
        handleCancelModal();
        convertRes2Blob(res);
      },
    },
  );
  const { run: _sendEmail } = useRequest((data) => exportReport(data), {
    manual: true,
    onSuccess: (res) => {
      handleCancelModal();
    },
  });

  useAfterDidMountEffect(() => {
    const allData = form.getFieldsValue();
    _reportDetailEdit({
      ...allData,
      ...allData.dateRange,
      category: type,
      filters: filtersData,
    });
  }, [pageSize, current]);
  const { Component, onOpen } = useFilter({
    value: filtersData,
    onChange: (e: any) => {
      let allData = form.getFieldsValue();
      allData = {
        ...allData,
        ...allData.dateRange,
        category: type,
        filters: e,
      };
      setHasModified(true);
      _reportDetailEdit(allData);
      setFiltersData(e);
      // console.log('e', e);
    },
  });

  const beforeGoBack = () => {
    history.push('/reportList');
  };
  const handleCancelModal = () => {
    setShowModal(false);
  };

  const handleSendToEmail = () => {
    form.validateFields().then(() => {
      setShowModal(true);
      setModalTitle(getI18n('reports.reportdetailcommon.sendtoemail'));
      setModalContent(
        <SendToEmail
          onCancel={handleCancelModal}
          onConfirm={(data) =>
            handleSendEmail('Email', data.format, data.emails)
          }
        />,
      );
    });
  };

  const onValuesChange = (values, allValues) => {
    const dateRange = get(allValues, 'dateRange.dateRange');
    const isCustom = IDateRange.Custom === dateRange;
    let allData = form.getFieldsValue();
    allData = { ...allData, ...allData.dateRange, category: type };
    setHasModified(true);
    if (isCustom) {
    } else {
      if (
        Object.keys(values).includes('dateRange') &&
        values['dateRange']['dateRange'] == IDateRange.Custom &&
        values['dateRange']['beginDate'] &&
        values['dateRange']['endDate']
      ) {
        allData.dateRange = values['dateRange']['dateRange'];
        allData.beginDate = values['dateRange']['beginDate'];
        allData.endDate = values['dateRange']['endDate'];
        allData.dateRangeType = values['dateRange']['dateRangeType'];
        allData.filters = filtersData;
        _reportDetailEdit(allData);
      }
      if (
        Object.keys(values).includes('dateRange') &&
        values['dateRange']['dateRange'] !== IDateRange.Custom
      ) {
        allData.dateRange = values['dateRange']['dateRange'];
        allData.dateRangeType = values['dateRange']['dateRangeType'];
        allData.filters = filtersData;
        _reportDetailEdit(allData);
      }
    }

    if (Object.keys(values).includes('reportCurrencyType')) {
      allData.reportCurrencyType = values['reportCurrencyType'];
      allData.filters = filtersData;
      _reportDetailEdit(allData);
    }
  };

  const handleRefresh = () => {
    const allData = form.getFieldsValue();
    form.validateFields(['dateRange']).then(() => {
      _reportDetailEdit({
        ...allData,
        ...allData.dateRange,
        category: type,
        filters: filtersData,
      });
    });
  };
  const handleSendEmail = (exportType, format, emails?) => {
    const allData = form.getFieldsValue();
    form.validateFields().then(() =>
      _sendEmail({
        ...allData,
        ...allData.dateRange,
        category: type,
        filters: filtersData,
        type: exportType,
        format,
        emails,
      }),
    );
  };

  const handleExport = (exportType, format, emails?) => {
    const allData = form.getFieldsValue();
    form.validateFields().then(() =>
      _exportReport({
        ...allData,
        ...allData.dateRange,
        category: type,
        filters: filtersData,
        type: exportType,
        format,
        emails,
      }),
    );
  };

  const overlay = (
    <Menu className={css.menu}>
      <MenuItem
        className={css.menuItem}
        onClick={(e) => handleExport('File', IExportFormat.CSV)}
        disabled={!add_edit_report}>
        {getI18n('reports.reportdetailcommon.overlay_csv')}
      </MenuItem>
      <MenuItem
        className={css.menuItem}
        onClick={(e) => handleExport('File', IExportFormat.Excel)}
        disabled={!add_edit_report}>
        {getI18n('reports.reportdetailcommon.overlay_excel')}
      </MenuItem>
      <MenuItem
        className={css.menuItem}
        onClick={handleSendToEmail}
        disabled={!add_edit_report}>
        {getI18n('reports.reportdetailcommon.overlay_email')}
      </MenuItem>
    </Menu>
  );

  const handleFinish = (values) => {
    _saveReport({
      ...values,
      ...values.dateRange,
      category: type,
      filters: filtersData,
      uuid: reportUuid === NEW ? '' : reportUuid,
    });
  };

  return (
    <Spin
      spinning={
        loading ||
        editLoading ||
        saveLoading ||
        exportLoading ||
        getReportDetailLoading
      }>
      {Component}
      <CommonHeader
        breadcrumbData={breadcrumbData(name, { getI18n })}
        onSaveDisable={!hasModified || !add_edit_report}
        disableDelete={!delete_report}
        onGoBackClick={beforeGoBack}
        onSubmit={() => form.submit()}
        onDiscard={beforeGoBack}
        {...(reportUuid !== NEW && { onDelete: _deleteReport })}
        extendButton={
          <DropDown.Button
            icon={<Icon type='icondown' />}
            className={css.extendButton}
            overlay={overlay}
            placement='bottomRight'
            trigger={['click']}>
            {getI18n('general.moreActions')}
          </DropDown.Button>
        }
      />
      <Form
        name='reportsDetail'
        onValuesChange={onValuesChange}
        form={form}
        onFinish={handleFinish}
        className={css.contain}>
        <ReportConfig
          name={name}
          type={type}
          storeCurrencyCode={storeCurrencyCode}
          disabled={!add_edit_report}
        />
        <ReportData
          onRefresh={handleRefresh}
          timeZone={timeZone}
          onOpen={onOpen}
          refreshDate={refreshDate}
          disabled={!add_edit_report}
          searchBtnLoading={editLoading}
        />
        <Table
          loading={editLoading}
          pageSize={pageSize}
          setPageSize={setPageSize}
          results={results}
          current={current}
          setCurrent={setCurrent}
          total={totalCount}
        />
      </Form>
    </Spin>
  );
};

export default ModalHoc(ReportsDetail);
